<template>
  <div class="content-tab">
    <template v-if="panels.length">
      <Content
        :children="panels"
        @positionChange="positionChanged"
        @click="setActive($event)"
        @delete="removePanel({ id: $event })"
        @resize="sizeChanged($event.id, $event.size)"
      />
    </template>

    <Button
      icon="fas fa-plus"
      :label="$t('add-panel')"
      class="content-tab__action-button"
      @click="addPanel({ parentId: id })"
    />

    <Button v-if="!isFromFunnel" icon="fas fa-plus" :label="$t('add-panel-with-form')" @click="batch('form', id)" />

    <Button
      v-if="panelCopied"
      icon="fas fa-paste"
      :label="$t('past-panel')"
      @click="pastePanel({ id: panelCopied, parentId: id })"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ContentMixin from '@/components/sidenav/landing/shared/ContentMixin.js'
import Content from '@/components/sidenav/shared/Content'
import Button from '@/shared/components/Button'
import FunnelMixin from '@/components/Mixin'

export default {
  name: 'SectionSideNavContentTab',
  i18nOptions: { keyPrefix: 'components.sidenav.landing.section.content' },
  mixins: [ContentMixin, FunnelMixin],
  components: { Content, Button },
  props: {
    panels: {
      type: Array,
      default() {
        return []
      },
    },
  },
  methods: mapActions('landing', ['removeSection']),
}
</script>

<style lang="scss" scoped>
.content-tab {
  padding: 8px;
}

.content-tab__action-button {
  margin-top: 24px;
  margin-bottom: 16px;
}
</style>
